import { render, staticRenderFns } from "./error-advice.vue?vue&type=template&id=29664c0d&"
import script from "./error-advice.vue?vue&type=script&lang=js&"
export * from "./error-advice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29664c0d')) {
      api.createRecord('29664c0d', component.options)
    } else {
      api.reload('29664c0d', component.options)
    }
    module.hot.accept("./error-advice.vue?vue&type=template&id=29664c0d&", function () {
      api.rerender('29664c0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/error-advice.vue"
export default component.exports